module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "progress",
    style: ({
      transform: _vm.transform,
      transition: _vm.transition,
      background: _vm.background
    })
  })]), _c('div', {
    staticClass: "label"
  }, [_c('animated-number', {
    attrs: {
      "number": _vm.progressLabel,
      "time": _vm.time
    }
  }), _c('span', [_vm._v("%")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be66ee4"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/ProgressBar.vue
// module id = 304
// module chunks = 1